import { render } from "./purchaseList.vue?vue&type=template&id=ae8d963e&scoped=true"
import script from "./purchaseList.vue?vue&type=script&lang=js"
export * from "./purchaseList.vue?vue&type=script&lang=js"

import "./purchaseList.vue?vue&type=style&index=0&id=ae8d963e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ae8d963e"

export default script